// extracted by mini-css-extract-plugin
module.exports = {"table":"FootprintsTable_table__jPCBX","th":"FootprintsTable_th__2quaj","tr":"FootprintsTable_tr__qMD56","td":"FootprintsTable_td__1noDV"};